import { Box, type BoxProps } from '@mantine/core'

import { useDocumentState } from '../../../booking-documents/hooks/useDocumentState'
import { SectionTable } from './SectionTable'

export type SectionContractContentProps = BoxProps

export function SectionContractContent({
  ...props
}: SectionContractContentProps) {
  const { documentPreview } = useDocumentState()

  const hasContractBody =
    documentPreview?.booking_settings?.contract_body &&
    documentPreview?.booking_settings?.contract_body !== '<p></p>' &&
    documentPreview?.booking_settings?.contract_body !==
      '\u003cp\u003e\u003c/p\u003e' &&
    documentPreview?.booking_settings?.contract_body !== null

  return (
    hasContractBody && (
      <SectionTable {...props}>
        <SectionTable.Body>
          <Box
            dangerouslySetInnerHTML={{
              __html: String(documentPreview?.booking_settings?.contract_body),
            }}
          />
        </SectionTable.Body>
      </SectionTable>
    )
  )
}
